import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/loading/:code?/:state?',
      name: 'Load',
      component: () => import('@/views/loading/index'),
      meta: {
        title: 'loading',
        requiresAuth: true
      }
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import('@/views/loading/not-found'),
      meta: {
        title: '404',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '手机绑定',
        requiresAuth: true
      }
    },
    {
      path: '/robot',
      name: 'Robot',
      component: () => import('@/views/robot/index.vue'),
      meta: {
        title: '机器人列表',
        requiresAuth: true
      }
    },
    {
      path: '/robotCreate/:currentIndex?',
      name: 'RobotCreate',
      component: () => import('@/views/robot/robot-create'),
      meta: {
        title: '创建机器人',
        requiresAuth: true
      }
    },
    {
      path: '/robotIndex',
      name: 'robotIndex',
      component: () => import('@/views/robotDetail/index'),
      redirect: { name: 'robotMsg' },
      children: [
        {
          path: '/robotMsg/:robotId',
          name: 'robotMsg',
          component: () => import('@/views/robotDetail/robotMsg/robot-msg'),
          meta: {
            title: '机器人信息',
            requiresAuth: true
          }
        },
        {
          path: '/skillShop/:robotId/:leftIndex?',
          name: 'skillShop',
          component: () => import('@/views/robotDetail/skillShop/skill-shop'),
          meta: {
            title: '机器人信息',
            requiresAuth: true
          }
        },
        {
          path: '/skillList/:robotId/:leftIndex?',
          name: 'skillList',
          component: () => import('@/views/robotDetail/skillList/skill-list'),
          meta: {
            title: '机器人列表',
            requiresAuth: true
          }
        },
        {
          path: '/knowledge/:robotId/:knowId/:leftIndex?',
          name: 'Knowledge',
          component: () => import('@/views/robotDetail/skillList/knowledge'),
          meta: {
            title: '知识库',
            requiresAuth: true
          }
        },
        {
          path: '/helpdoc/:robotId/:leftIndex?',
          name: 'Helpdoc',
          redirect: {name: 'weixinHelp'}
        },
        {
          path: '/weixinHelp/:robotId/:childIndex?',
          name: 'weixinHelp',
          component: () => import('@/views/robotDetail/helpDoc/weixin')
        },
        {
          path: '/wxgroupHelp/:robotId/:childIndex?',
          name: 'wxGroupHelp',
          component: () => import('@/views/robotDetail/helpDoc/weixinGroup')
        },
        {
          path: '/qqgroupHelp/:robotId/:childIndex?',
          name: 'qqGroupHelp',
          component: () => import('@/views/robotDetail/helpDoc/qqGroup')
        },
        {
          path: '/apiHelp/:robotId/:childIndex?',
          name: 'apiHelp',
          component: () => import('@/views/robotDetail/helpDoc/api')
        },
        {
          path: '/usualHelp/:robotId/:childIndex?',
          name: 'usualHelp',
          component: () => import('@/views/robotDetail/helpDoc/usualdoc')
        },
        {
          path: '/developHelp/:robotId/:childIndex?',
          name: 'developHelp',
          component: () => import('@/views/robotDetail/helpDoc/develop')
        }
      ]
    },
    {
      path: '/',
      name: '',
      component: () => import('@/views/index'),
      redirect: { name: 'Platfrom' },
      children: [
        {
          path: '/chat',
          name: 'Chat',
          component: () => import('@/views/home/erweima'),
          meta: {
            title: '对话体验',
            requiresAuth: true
          }
        },
        {
          path: '/scene',
          name: 'Scene',
          component: () => import('@/views/home/scene'),
          meta: {
            title: '应用场景',
            requiresAuth: true
          }
        },
        {
          path: '/about',
          name: 'About',
          component: () => import('@/views/home/about'),
          meta: {
            title: '关于图灵',
            requiresAuth: true
          }
        },
        // {
        //   path: '/products',
        //   name: 'Products',
        //   component: () => import('@/views/home/products'),
        //   meta: {
        //     title: '图灵精品之家',
        //     requiresAuth: true
        //   }
        // },
        {
          path: '/',
          name: 'Platfrom',
          component: () => import('@/views/home/platfrom'),
          meta: {
            title: '首页',
            requiresAuth: true
          }
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.name === 'Platfrom') {
    store.dispatch('setConShow', false)
    store.dispatch('setTopbar', false)
    store.dispatch('setFootbar', false)
  } else if (to.name === 'Chat') {
    store.dispatch('setConShow', false)
    store.dispatch('setTopbar', true)
    store.dispatch('setFootbar', false)
  } else if (to.name === 'Products') {
    store.dispatch('setConShow', true)
    store.dispatch('setTopbar', true)
    store.dispatch('setFootbar', true)
  } else {
    store.dispatch('setConShow', false)
    store.dispatch('setTopbar', true)
    store.dispatch('setFootbar', true)
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js